import { render, staticRenderFns } from "./PriceTrendChart.vue?vue&type=template&id=2affc456&scoped=true"
import script from "./PriceTrendChart.vue?vue&type=script&lang=js"
export * from "./PriceTrendChart.vue?vue&type=script&lang=js"
import style0 from "./PriceTrendChart.vue?vue&type=style&index=0&id=2affc456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2affc456",
  null
  
)

export default component.exports